'use client';

import { ComponentProps } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';

import { SelectField } from './SelectField';
import { StateField } from './StateField';
import { TextAreaField } from './TextAreaField';
import { TextField } from './TextField';

type StringField = Omit<ComponentProps<typeof TextField>, 'type'> & {
    type: 'text' | 'email' | 'password' | 'number' | 'url' | 'tel';
};

type DropdownField = ComponentProps<typeof SelectField> & {
    type: 'dropdown';
};

type StateSelectField = ComponentProps<typeof StateField> & {
    type: 'state';
};

type LongStringField = ComponentProps<typeof TextAreaField> & {
    type: 'longtext';
};

export type FormInputProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = (StringField | StateSelectField | LongStringField | DropdownField) & {
    name: TName;
};

export function FormInput<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(props: FormInputProps<TFieldValues, TName>) {
    switch (props.type) {
        case 'text':
        case 'email':
        case 'password':
        case 'number':
        case 'url':
        case 'tel':
            return <TextField {...props} />;
        case 'dropdown':
            return <SelectField {...props} />;
        case 'state':
            return <StateField {...props} />;
        case 'longtext':
            return <TextAreaField {...props} />;
        default:
            return null;
    }
}
